import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Incapacidad } from '../../interfaces/incapacidad';
import { ServicioIncapacidadService } from '../../services/servicio-incapacidad.service';
import { ImagesService } from '../../services/utils/images.service';

@Component({
  selector: 'app-reporte-incapacidad1427',
  templateUrl: './reporte-incapacidad1427.component.html',
  styleUrls: ['./reporte-incapacidad1427.component.css']
})
export class ReporteIncapacidad1427Component implements OnInit {

  private unco: number = 0;
  private tipo: number = 0;
  
  public code: string = '';
  public uncoSede: number = 0;
  public incapacidad: Incapacidad;
  public loading: boolean = true;
  public firmaProfesional: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private incapacidadService: ServicioIncapacidadService,
    private servicioImagenes: ImagesService,
  ) {
    this.activatedRoute.params.subscribe((param: any) => {
      this.code = String(param['codigoBaseDatos']);
      this.unco = Number(param['unco']);
      this.tipo = Number(param['tipo']);
      this.uncoSede = Number(param['uncoSede']);
    });
  }

  ngOnInit() {
    this.getIncapacidades();
  }

  public getGenerar(event: boolean) {    
    if (event) {
      this.loading = !this.loading;
      this.getIncapacidades();
    }
  }

  public getIncapacidades() {
    this.incapacidadService.getIncapacidades(this.code, this.unco, this.tipo).subscribe((data: Incapacidad) => {
      console.log('Incapacidades', data);
      if (data) {
        this.incapacidad = data;

        this.getFirmaProfesional(this.incapacidad.uncoProfesional);
      }

      this.loading = !this.loading;
    }, (err: any) => {
      this.loading = !this.loading;
      console.error(err);
    });
  }

  private async getFirmaProfesional(uncoProfesional: number) {
    try {
      const response = await this.servicioImagenes.getFirmaProfesional(this.code, uncoProfesional);
      response.subscribe((data: any) => {
        this.firmaProfesional = data.source;
      }, (err: any) => {
        console.error(err);
      });
    } catch (e) {
      console.log('Error obteniendo firma profesional', e);
    }
  }

}
